module.exports = __webpack_public_path__ + "img/steward-guide.0ff8b635.gif";